export default "__VITE_ASSET__DLpV1F8k__"